<div class="backDrop" *ngIf="showDialog$ | async">
    <div class="modal-dialog modal-s">
        <div class="modal-content ">
            <div>
                <div class="modal-header ">
                    <h4 class="modal-title">Delete Link</h4>
                </div>

                <div class="modal-body">
                    <div>Are you sure you want to delete this link?</div>
                    <div>This will also delete related objects such as mappings and logs, and may have irreversible consequences!</div>
                    <div>Please only delete this link if you are not going to use this integration anymore.</div>
                    <div>The delete button will only be enabled after 10 seconds.</div>
                </div>

                <div class="modal-footer" *ngIf="{deleteDisableCounter: deleteDisableCounter$ | async} as context">
                    <button type="button" class="btn btn-success" (click)="confirm()" [disabled]="context.deleteDisableCounter > 0">
						Delete <ng-container *ngIf="context.deleteDisableCounter > 0">({{context.deleteDisableCounter}})</ng-container>
					</button>
                    <button type="button" class="btn btn-primary" (click)="cancel()">
						Cancel
					</button>
                </div>
            </div>
        </div>
    </div>
</div>
